import create from './create'
import export_ from './export'

export default {
  loading: 'Завантаження чатів...',
  empty: 'Немає чатів',

  type: {
    image: 'Зображення',
    document: 'Документ',
    video: 'Відео',
  },

  select_assigned: {
    title: '',
    all: 'Всі чати',
    assigned_me: 'Призначені на мене',
    favorite: 'Улюблені',
    resolved: 'Вирішені чати',
  },
  select_status: {
    title: 'Статус',
    all: 'Всі',
    0: 'Новий',
    1: 'Чат',
    2: 'Вирішено',
  },

  create,
  export: export_,
}
